export default (settings) => {
  if (!settings.selector || !settings.handler) {
    consoler.error('Interscetion Loader requires at least a selector AND a handler')
  }

  const $elements = document.querySelectorAll(settings.selector)

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return
      }
  
      settings.handler(entry)

      observer.unobserve(entry.target)
    })
  }, settings.options || {});

  $elements.forEach(($element) => observer.observe($element))
}